import { render, staticRenderFns } from "./orderCheckbox.vue?vue&type=template&id=6736708a&scoped=true"
import script from "./orderCheckbox.vue?vue&type=script&lang=js"
export * from "./orderCheckbox.vue?vue&type=script&lang=js"
import style0 from "./orderCheckbox.vue?vue&type=style&index=0&id=6736708a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6736708a",
  null
  
)

export default component.exports